(() => {
  'use strict';

  if (window.__nbhCartCountInitialized) return;
  window.__nbhCartCountInitialized = true;

  const getCartLinks = () => document.querySelectorAll('.nbh-header__cart');

  const renderCartCount = (rawCount) => {
    const count = Math.max(0, Number.parseInt(rawCount, 10) || 0);

    getCartLinks().forEach((link) => {
      let badge = link.querySelector('.nbh-header__cart-count');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'nbh-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = count > 99 ? '99+' : String(count);
      } else {
        badge?.remove();
      }

      link.setAttribute('aria-label', `Kurv med ${count} ${count === 1 ? 'vare' : 'varer'}`);
    });
  };

  const refreshCartCount = async () => {
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const response = await fetch(`${cartUrl}.js`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const cart = await response.json();
      renderCartCount(cart.item_count);
    } catch (_error) {
      // Keep the server-rendered count if the cart request fails.
    }
  };

  const subscribeToCartUpdates = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
      return;
    }
    window.setTimeout(subscribeToCartUpdates, 50);
  };

  refreshCartCount();
  subscribeToCartUpdates();

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCartCount();
  });
})();
